import { createStore } from 'redux';
import reducer from './reducer';

export default createStore(
  reducer
  /* applyMiddleware(logger, crashReporter) */ //applyMiddleware() tells createStore() how to handle middleware
)


// WEBPACK FOOTER //
// ./src/app/res/store.js